import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function SiteSwitcher({ currentSiteId }) {
  var navigate = useNavigate();
  var [sites, setSites] = useState([]);
  var [open, setOpen] = useState(false);
  var [filter, setFilter] = useState('');
  var ref = useRef(null);

  useEffect(function() {
    api.getSitesList().then(function(data) {
      setSites(data.sites || []);
    }).catch(function() {});
  }, []);

  // Close on outside click
  useEffect(function() {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setFilter('');
      }
    }
    if (open) document.addEventListener('mousedown', handleClick);
    return function() { document.removeEventListener('mousedown', handleClick); };
  }, [open]);

  var currentSite = sites.find(function(s) { return String(s.id) === String(currentSiteId); });
  var filtered = sites.filter(function(s) {
    if (!filter) return true;
    var q = filter.toLowerCase();
    return s.name.toLowerCase().includes(q) || s.url.toLowerCase().includes(q);
  });

  function switchTo(siteId) {
    setOpen(false);
    setFilter('');
    // Preserve current sub-path
    var currentPath = window.location.pathname.replace(process.env.PUBLIC_URL || '', '');
    var subPath = currentPath.replace(/\/sites\/\d+/, '');
    navigate('/sites/' + siteId + (subPath || ''));
  }

  return (
    <div className="site-switcher" ref={ref}>
      <button
        className="site-switcher-btn"
        onClick={function() { setOpen(!open); }}
        title={'\u05de\u05e2\u05d1\u05e8 \u05d1\u05d9\u05df \u05d0\u05ea\u05e8\u05d9\u05dd'}
      >
        <span className="site-switcher-name">
          {currentSite ? currentSite.name : '\u05d1\u05d7\u05e8 \u05d0\u05ea\u05e8'}
        </span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2"
          style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
          <path d="M3 5l3 3 3-3"/>
        </svg>
      </button>

      {open && (
        <div className="site-switcher-dropdown">
          <div className="site-switcher-search">
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="6" cy="6" r="4"/><path d="m9 9 2.5 2.5"/>
            </svg>
            <input
              type="text"
              placeholder={'\u05d7\u05d9\u05e4\u05d5\u05e9 \u05d0\u05ea\u05e8...'}
              value={filter}
              onChange={function(e) { setFilter(e.target.value); }}
              autoFocus
            />
          </div>
          <div className="site-switcher-list">
            {filtered.length === 0 && (
              <div className="site-switcher-empty">{'\u05d0\u05d9\u05df \u05ea\u05d5\u05e6\u05d0\u05d5\u05ea'}</div>
            )}
            {filtered.map(function(s) {
              return (
                <div
                  key={s.id}
                  className={'site-switcher-item' + (String(s.id) === String(currentSiteId) ? ' active' : '')}
                  onClick={function() { switchTo(s.id); }}
                >
                  <div className="site-switcher-item-favicon">
                    {(s.name || '?').charAt(0).toUpperCase()}
                  </div>
                  <div className="site-switcher-item-info">
                    <div className="site-switcher-item-name">{s.name}</div>
                    <div className="site-switcher-item-url">{s.url.replace(/^https?:\/\//, '')}</div>
                  </div>
                  {String(s.id) === String(currentSiteId) && (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="var(--accent)" strokeWidth="2.5">
                      <path d="M2.5 7l3 3 6-6"/>
                    </svg>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
